import { Empty, Pagination, TablePaginationConfig } from 'antd';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { theme } from '../constants/theme';
import { CallForTender } from '../slices/callForTender';
import { CallForTenderCard } from './cards/callForTenderCard';

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    justifyContent: 'center',
    maxWidth: '1330px',
  },
  flexWrapper: {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'start',
    flexWrap: 'wrap',
    gap: '20px',
    rowGap: '0px',
  },
  flexItem: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  pagination: {
    margin: '20px 0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    maxWidth: '1330px',
    '& .ant-pagination-item': {
      borderRadius: '6px',
      border: 'none',
      padding: '2px 8px',
      '&-active': {
        fontFamily: 'PP Mori',
        fontSize: '14px',
        fontWeight: '400',
        color: theme.palette.primary,
        backgroundColor: '#F3F6FD',
      },
    },
    '& .ant-pagination-item-link': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      border: 'none',
      borderRadius: '6px',
      background: 'none',
      color: '#737373',
      fontSize: '14px',
      '&:hover': {
        color: '#737373',
      },
      '& .ant-pagination-item-link-icon': {
        opacity: '0 !important',
        display: 'none !important',
      },
      '& .ant-pagination-item-ellipsis': {
        opacity: '1 !important',
        display: 'block !important',
        marginLeft: '-8px',
      },
    },
  },
});

interface CallForTenderCardsProps {
  callForTenders: CallForTender[] | null;
  onTableChange: (pagination: TablePaginationConfig) => void;
  loading: boolean;
  pagination?: false | TablePaginationConfig | undefined;
  redirectNewPage?: boolean;
  disableClick?: boolean;
  onPaywallRedirect?: () => void;
}

export const CallForTenderCards = ({
  callForTenders,
  onTableChange,
  loading,
  pagination,
  redirectNewPage = false,
  disableClick = false,
  onPaywallRedirect,
}: CallForTenderCardsProps) => {
  const classes = useStyles();

  const itemRender = (
    page: number,
    type: 'page' | 'prev' | 'next' | 'jump-prev' | 'jump-next',
    element: React.ReactNode,
  ) => {
    if (type === 'page') {
      return page < 10 ? `0${page}` : page;
    }
    return element;
  };

  return (
    <>
      {!loading && callForTenders?.length === 0 && (
        <Empty description={`Aucun appel à projets pour le moment...`} />
      )}
      {!loading && (
        <div className={classes.container}>
          <div className={classes.flexWrapper}>
            {callForTenders?.map((cft) => (
              <div key={cft._id} className={classes.flexItem}>
                <CallForTenderCard
                  callForTender={cft}
                  redirectNewPage={redirectNewPage}
                  disableClick={disableClick}
                  onPaywallRedirect={onPaywallRedirect}
                />
              </div>
            ))}
          </div>
          {pagination && (
            <Pagination
              {...pagination}
              className={classes.pagination}
              onChange={(page) => onTableChange({ current: page })}
              itemRender={itemRender}
            />
          )}
        </div>
      )}
    </>
  );
};
